<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-05 21:42:33
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-06 01:07:47
-->
<template>
  <div class="table">
    <a-tabs>
      <a-tab-pane key="1" tab="专利申请">
        <!-- <div class="tool-box">
          <a-button @click="handleAdd" type="primary">新增</a-button>
        </div> -->
        <a-table :data-source="data" :columns="columns" rowKey="id" style="width: 100%">
          <span slot="agencyzId" slot-scope="text">{{ fmtAgency(text) }}</span>
          <span slot="patentType" slot-scope="text">{{ fmtTypes(text) }}</span>
          <span slot="status" slot-scope="text">{{ fmtStatus(text) }}</span>
          <template slot="operation" slot-scope="text, record">
            <a
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleDetail(record)"
              >详情</a
            >
               <!--<a
               v-if="iszhuang"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handestatus(record)"
              >{{record.status==0?'等待审核':record.status==1?'提交专利局':'申请成功'}}</a
            >-->
            <a
              v-if="userInfo && userInfo.type != '代理机构'"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleEdit(record)"
              >修改</a
            >
             <a
              v-if="userInfo && userInfo.type == '代理机构'"
              href="javascript:;"
              style="margin-right: 8px"
              @click="() => handleEditStatus(record)"
              >修改状态</a
            >
            <a-popconfirm
              v-if="userInfo && userInfo.type != '代理机构'"
              title="请确认是否删除?"
              @confirm="() => onDelete(record)"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      @ok="handleOk"
            okText="确定" cancelText="取消"
      @cancel="handleCancel"
    >
      <a-form-model v-model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item label="专利名称">
          <a-input v-if="isEdit" v-model="form.patentName" :disabled="!isEdit" />
          <span v-else>{{ form.patentName }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利描述">
          <a-input v-if="isEdit" v-model="form.patentDesc" :disabled="!isEdit" />
          <span v-else>{{ form.patentDesc }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利类型">
          <a-select v-if="isEdit" v-model="form.patentType" :disabled="!isEdit">
            <a-select-option v-for="item in types" :key="item.key" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ fmtTypes(form.patentType) }}</span>
        </a-form-model-item>
        <a-form-model-item label="专利权人">
          <a-input v-if="isEdit" v-model="form.patentee" :disabled="!isEdit" />
          <span v-else>{{ form.patentee }}</span>
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-select v-if="isEditStatus" v-model="form.status" :disabled="!isEditStatus">
            <a-select-option v-for="(item, index) in status" :key="item" :value="index">
              {{ item.value }}
            </a-select-option>
          </a-select>
          <span v-else>{{ status &&fmtStatus(form.status)}}</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "专利名称",
    dataIndex: "patentName",
    key: "patentName",
    width: 120,
    ellipsis: true,
  },
  {
    title: "专利描述",
    dataIndex: "patentDesc",
    key: "patentDesc",
    width: 150,
    ellipsis: true,
  },
  {
    title: "专利类型",
    dataIndex: "patentType",
    key: "patentType",
    scopedSlots: { customRender: "patentType" },
    width: 120,
    ellipsis: true,
  },
  {
    title: "专利权人",
    dataIndex: "patentee",
    key: "patentee",
    width: 120,
    ellipsis: true,
  },
  {
    title: "代理机构",
    dataIndex: "agencyzId",
    key: "agencyzId",
    width: 120,
    ellipsis: true,
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" },
    width: 180,
    ellipsis: true,
  },
  {
    title: "操作",
    dataIndex: "operation",
    key: "id",
    scopedSlots: { customRender: "operation" },
  },
];
import request from "../util/request";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
export default {
  name: "user-center-register",
  data() {
    return {
      locale,
      data: [],
      columns,
      types: [],
      org: [],
      iszhuang:false,
      page: {
        page: 1,
        pageSize: 999,
      },
      title: "",
      visible: false,
      confirmLoading: false,
      isEdit: false,
      isEditStatus: false,
      isEditFlag: false,
      parents: [],
      form: {},
      status: [],
      userInfo: {},
    };
  },
  mounted() {
    const userInfo = localStorage.getItem("userInfo");
      
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      console.log(this.userInfo.type)
      if(this.userInfo.type=='代理机构'){
        this.iszhuang = true;
      }
      console.log(this.userInfo.menuVOS);
    }
    this.queryDict();
    this.queryDict1();
    //  this.queryOrg();
    this.queryList();
 

  },
  methods: {
    handleDetail(record) {
      request({
        url: `/api/center/order/patentregister/${record.id}`,
      }).then((res) => {
        this.visible = true;
        this.title = "详情";
        this.isEdit = false;
        this.isEditStatus = false;
        this.form = res.data;
      });
    },
    onDelete(record) {
      request({
        url: "/api/center/order/patentregister/" + record.id,
        method: "delete",
      }).then((res) => {
        this.$message.info(res.msg);
        this.queryList();
      });
    },
    handestatus(record){
           const params ={id:record.id,status:''}
        if(record.status == 0){
         params.status = 1
        }
        if(record.status == 1){
           params.status = 2
        }
        if(record.status == 2){
          params.status = 3
        }
        
 
         request({
          url: "/api/center/order/patentregister/",
          method: "put" ,
          params,
        }).then((res) => {
          if (res.msg == "success") {
            this.$message.info("操作成功");
            this.visible = false;
            this.form = {};
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    handleEdit(record) {
      this.visible = true;
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(record));
      delete this.form.children;
      this.isEdit = true;
      this.isEditStatus = false;
    },
    handleEditStatus(record) {
      this.visible = true;
      this.title = "修改";
     request({
        url: `/api/center/order/patentregister/${record.id}`,
      }).then((res) => {
        this.form = res.data;
      });
      delete this.form.children;
      this.isEdit = false;
      this.isEditStatus = true;
    },
    handleAdd() {
      this.isEdit = true;
      this.isEditStatus = false;
      this.title = "新增";
      this.visible = true;
      this.form = {};
    },
    handleOk() {
      this.form.towingpipeLabel="";
      const params = Object.assign({}, this.form);
      if(this.isEditStatus==false&&this.isEdit==true){
          this.isEditFlag=true;
      }
       if(this.isEditStatus==true&&this.isEdit==false){
          this.isEditFlag=true;
      }
      if (this.isEditFlag) {
        request({
          url: "/api/center/order/patentregister/",
          method: this.title == "修改" ? "put" : "post",
          params,
        }).then((res) => {
          if (res.code == "200") {
            this.$message.info("操作成功");
            this.visible = false;
            this.form = {};
            this.queryList();
          } else {
            this.$message.warning(res.msg);
          }
        });
      } else {
        this.visible = false;
        this.form = {};
      }
    },
    fmtTypes(text) {
      console.log(text)
       console.log(this.types)
      const result = this.types.find((ele) => ele.key == text);
        
      console.log(result)
      return result ? result.value : "";
    },
    fmtStatus(text) {
      console.log(text)
       console.log(this.status)
      const result = this.status.find((ele) => ele.key == text);
        
      console.log(result)
      return result ? result.value : "";
    },
    fmtAgency(text) {
 
      const result = this.org.find((ele) => ele.key == text);
      return result ? result.value : "";
    },
    queryDict() {
      request({
        url: "/api/client/common/select/dict/list",
        params: {
          key: "patentType",
        },
      }).then((res) => {
        console.log("dict", res);
         if (res.code == "200") {
           this.types = res.data;
        }
      });
    },
      queryDict1() {
        request({
          url: "/api/client/common/select/dict/list",
          params: {
            key: "regedit_status",
          },
        }).then((res) => {
          console.log("dict", res);
          
          if (res.code == "200") {
            this.status = res.data;
          }
        });
      },
    queryOrg() {
      request({
           url: "/api/client/common/select/enterprise/list?key=ORG_OWNER",
      }).then((res) => {
         if (res.code == "200") {
           this.org = res.data;
        }
      });
    },
    queryList() {
      request({
        url: "/api/center/order/patentregister/list",
        params: this.page,
      }).then((res) => {
        if (res.code == "200") {
          this.data = res.data.records;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.form = false;
    },
  },
};
</script>

<style lang="less"></style>
